import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Lenis from "lenis";
import { EnquiryProvider, EnquiryDrawer, FloatingCartButton } from "@/components/EnquiryCart";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Disclaimer from "@/pages/Disclaimer";
import Admin from "@/pages/Admin";

const Intro = () => (
  <motion.div
    data-testid="intro-curtain"
    className="fixed inset-0 z-[100] flex items-center justify-center bg-forest-dark"
    initial={{ y: 0 }}
    animate={{ y: "-100%" }}
    transition={{ delay: 1.2, duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
  >
    <span className="block overflow-hidden px-4">
      <motion.span
        className="block font-serif italic text-3xl sm:text-5xl text-bone"
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.75, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
      >
        Shivam Kirana Store
      </motion.span>
    </span>
  </motion.div>
);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <EnquiryProvider>
        <Intro />
        <ScrollToTop />
        <div className="App min-h-screen bg-bone text-ink font-sans">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </div>
        <FloatingCartButton />
        <EnquiryDrawer />
      </EnquiryProvider>
    </BrowserRouter>
  );
}

export default App;
